import React from 'react';
import { Loader, BaasicConfirmModal, BaasicTable, BaasicModal, BaasicHeader, BaasicSelect } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { CarrierEdit } from 'modules/carrier/pages';

const CarrierListTemplate = ({
	t,
	viewStore,
	viewStore: {
		loading,
		listStore,
		tableData,
		queryUtility,
		deleteConfirmModal,
		editModal,
		showActions,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<React.Fragment>
			<BaasicHeader title="MAINMENU.ADMINISTRATION.SHIPPINGCARRIERS"></BaasicHeader>
			<BaasicTable
				{...{
					listStore,
					tableData,
					queryUtility,
					viewStore,
					showActions,
				}}
				data={listStore.data.slice()}
				actions={viewStore}
			/>
			<BaasicConfirmModal modalParams={deleteConfirmModal} />
			<BaasicModal modalParams={editModal}>
				<CarrierEdit />
			</BaasicModal>
		</React.Fragment>
	);
};

export default defaultTemplate(CarrierListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/carrier/pages/CarrierListTemplate.jsx